export const TYPE_PROJECT_SHOW = 'project_show';
export const TYPE_COMPANIES = 'type_companies';
export const TYPE_PROJECTS = 'type_projects';
export const TYPE_ARCHIVE_PROJECT = 'type_archive_project';
export const TYPE_RESTORE_PROJECT = 'type_restore_project';
export const TYPE_DATASOURCES_VERSIONS = 'type_datasources_versions';
export const TYPE_DATASOURCES_INGREDIENTS_BY_VERSIONS = 'type_datasources_ingredients_by_versions';
export const TYPE_PROJECT_BY_ID = 'project_by_id';
export const TYPE_SHOW_PROJECT_JOB = 'show_project_job';
export const TYPE_CANCEL_JOB = 'cancel_job';
export const TYPE_VIEW_JOB = 'view_job';
export const TYPE_VIEW_JOB_STATUS = 'view_job_status';
export const TYPE_JOB_QUERY = 'job_query';
export const TYPE_INGREDIENT_AROMA_VIZ_PAGE = 'type_ingredient_aroma_viz_page';
export const TYPE_AROMA_DATA_BY_PRODUCT_PREP_ID = 'type_aroma_data_by_product_prep_id';
export const TYPE_LIST_AROMA_PROFILES = 'type_list_aroma_profiles';
export const TYPE_ADD_NEW_AROMA_PROFILE_VARIANT = 'type_add_new_aroma_profile_variant';
export const TYPE_UPDATE_AROMA_PROFILE_VARIANT = 'type_update_aroma_profile_variant';
export const TYPE_PROJECT_COMPANIES = 'type_project_companies';
export const TYPE_CLONE_PROJECT = 'clone_project';
export const TYPE_PROJECT_QUERY = 'project_query';
export const TYPE_BQ_CONNECTOR = 'bq_connector';
export const TYPE_GET_INGREDIENT_DB = 'get_ingredient_db';
export const TYPE_UPDATE_PROJECT = 'update_project';
export const TYPE_PROJECT_ID = 'project_id';

export type BuildActionRecordType = {
  projectId?: string | number;
  name?: string | number;
  jobId?: string | number;
  version?: string | number;
  queryParams?: string;
  productPreparationId?: string | number;
  profileName?: string;
  socialPostVersion?: string | number;
  category?: string;
};

/**
 * Build url by type.
 *
 * @param record
 * @param type
 */
export function buildActionUrl(record: BuildActionRecordType, type: string): string {
  switch (type) {
    case TYPE_PROJECT_SHOW:
      return `/projects/${record.projectId}/show`;
    case TYPE_PROJECT_ID:
      return `/v1/projects/${record.projectId}`;
    case TYPE_PROJECT_COMPANIES:
      return `/v1/projects/companies`;
    case TYPE_COMPANIES:
      return `/v1/companies`;
    case TYPE_PROJECTS:
      return `/v1/projects`;
    case TYPE_ARCHIVE_PROJECT:
      return `/v1/projects/${record.projectId}/archive`;
    case TYPE_RESTORE_PROJECT:
      return `/v1/projects/${record.projectId}/restore`;
    case TYPE_DATASOURCES_VERSIONS:
      return `/v1/datasources/versions`;
    case TYPE_DATASOURCES_INGREDIENTS_BY_VERSIONS:
      return `/v1/datasources/core/${record.version}/ingredients`;
    case TYPE_PROJECT_BY_ID:
      return `/v1/projects/${record.projectId}`;
    case TYPE_SHOW_PROJECT_JOB:
      return `/projects/${record.projectId}/jobs/${record.jobId}`;
    case TYPE_CANCEL_JOB:
      return `/v1/projects/${record.projectId}/jobs/${record.jobId}/abort`;
    case TYPE_VIEW_JOB:
      return `/v1/projects/${record.projectId}/jobs/${record.jobId}`;
    case TYPE_JOB_QUERY:
      return `/v1/jobs/query`;
    case TYPE_VIEW_JOB_STATUS:
      return `/v1/projects/${record.projectId}/jobs/${record.jobId}/status`;
    case TYPE_INGREDIENT_AROMA_VIZ_PAGE:
      return `/v1/data/aroma/${record.version}${record.queryParams ? record.queryParams : ''}`;
    case TYPE_AROMA_DATA_BY_PRODUCT_PREP_ID: {
      const { profileName = 'default', productPreparationId, version } = record;
      const suffix = profileName && profileName.toLowerCase() !== 'default' ? `variant/${profileName}` : 'default';
      return `/v1/datasources/core/${version}/ingredient/${productPreparationId}/aroma/${suffix}`;
    }
    case TYPE_LIST_AROMA_PROFILES:
      return `/v1/datasources/core/${record.version}/ingredient/${record.productPreparationId}/aroma`;
    case TYPE_ADD_NEW_AROMA_PROFILE_VARIANT:
      return `/v1/datasources/core/${record.version}/ingredient/${record.productPreparationId}/aroma/variant`;
    case TYPE_UPDATE_AROMA_PROFILE_VARIANT:
      return `/v1/datasources/core/${record.version}/ingredient/${record.productPreparationId}/aroma/variant/${record.profileName}/update`;
    case TYPE_CLONE_PROJECT:
      return `/v1/projects/${record.projectId}/clone`;
    case TYPE_PROJECT_QUERY:
      return `/v1/projects/query`;
    case TYPE_BQ_CONNECTOR:
      return `/v1/bqconnector/query`;
    case TYPE_GET_INGREDIENT_DB:
      return `/v1/datasources/ingredientdb/${record.version}/ingredients`;
    case TYPE_UPDATE_PROJECT:
      return `/v1/projects/${record.projectId}/update`;
    default:
      return '';
  }
}
